import { FC, useMemo } from 'react'

import { TimesRoundIcon } from 'components/Images/Icons'
import cn from 'classnames'
import { useTranslation } from 'next-i18next'
import styles from './ErrorMessage.module.scss'

interface IMessages {
  [key: string]: string[]
}
interface IErrorMessage {
  icon?: FC
  message: string | IMessages
  className?: string
}
const ErrorMessage: FC<IErrorMessage> = ({ icon, message, className }) => {
  const { t } = useTranslation()

  const Icon = icon

  const text = useMemo(() => {
    if (typeof message !== 'string') {
      const entries: [string, string[]][] = Object.entries(message)
      return (
        <div className={styles.errors}>
          {entries.map(([key, value], kid) => {
            return (
              <div key={kid}>
                {value.map((val, vid) => {
                  return (
                    <div key={vid}>
                      <span className={styles.key}>{key}</span>: {t(val)}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      )
    }
    return (
      <>
        {Icon ? <Icon /> : <TimesRoundIcon />}
        {t(message)}
      </>
    )
  }, [t, message])

  return <div className={cn(styles.error, className)}>{text}</div>
}

export default ErrorMessage
